// Delegated +/- handling for quantity steppers. Bound once (not per
// Turbolinks visit) since the listener works via event delegation.
//
// Steppers marked `.js-cart-qty-stepper` (cart panel rows for items already
// in the cart) push the new quantity to the server immediately and patch the
// line total / subtotal / counts in place, no page reload and no separate
// "Update" click needed. Plain steppers (the shop grid's pre-add-to-cart
// quantity picker) just adjust the input's value for the eventual submit.

function csrfToken() {
  var meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : ''
}

function sendCartUpdate(stepper, quantity) {
  var url = stepper.dataset.updateUrl
  if (!url) return

  fetch(url, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-CSRF-Token': csrfToken(),
      Accept: 'application/json'
    },
    body: 'quantity=' + encodeURIComponent(quantity)
  })
    .then(function (response) { return response.json() })
    .then(function (data) {
      var itemId = stepper.dataset.cartItemId
      var lineTotalEl = document.getElementById('cart-line-total-' + itemId)
      if (lineTotalEl && data.line_total) lineTotalEl.textContent = '$' + data.line_total

      var subtotalEl = document.getElementById('cart-panel-subtotal')
      if (subtotalEl) subtotalEl.textContent = '$' + data.cart_subtotal

      var feeEl = document.getElementById('cart-panel-fee')
      if (feeEl) feeEl.textContent = '$' + data.processing_fee
      var taxEl = document.getElementById('cart-panel-tax')
      if (taxEl) taxEl.textContent = '$' + data.tax_amount
      var totalEl = document.getElementById('cart-panel-total')
      if (totalEl) totalEl.textContent = '$' + data.cart_total

      // Minimum order: show/hide the notice and enable/disable checkout to match.
      var belowMinimum = parseFloat(data.minimum_shortfall) > 0
      var noticeEl = document.getElementById('cart-panel-min-notice')
      if (noticeEl) noticeEl.hidden = !belowMinimum
      var shortfallEl = document.getElementById('cart-panel-shortfall')
      if (shortfallEl) shortfallEl.textContent = data.minimum_shortfall
      document.querySelectorAll('.js-checkout-link').forEach(function (link) {
        link.classList.toggle('is-disabled', belowMinimum)
        link.setAttribute('aria-disabled', belowMinimum ? 'true' : 'false')
      })

      var countEl = document.getElementById('cart-panel-count')
      if (countEl) countEl.textContent = data.cart_item_count

      var badgeEl = document.getElementById('header-cart-badge')
      if (badgeEl) badgeEl.textContent = data.cart_item_count
    })
    .catch(function () {
      // Network hiccup: fall back to a normal page load so the cart stays correct.
      window.location.reload()
    })
}

document.addEventListener('click', function (event) {
  var button = event.target.closest('.qty-btn')
  if (!button) return

  var stepper = button.closest('.qty-stepper')
  var input = stepper && stepper.querySelector('input[type="number"]')
  if (!input) return

  event.preventDefault()

  var min = parseInt(input.min, 10) || 1
  var value = parseInt(input.value, 10) || min
  value = button.dataset.step === 'down' ? Math.max(min, value - 1) : value + 1

  input.value = value

  if (stepper.classList.contains('js-cart-qty-stepper')) sendCartUpdate(stepper, value)
})

document.addEventListener('change', function (event) {
  var input = event.target.closest('.js-cart-qty-stepper .qty-input')
  if (!input) return

  var stepper = input.closest('.qty-stepper')
  var min = parseInt(input.min, 10) || 1
  var value = Math.max(min, parseInt(input.value, 10) || min)
  input.value = value

  sendCartUpdate(stepper, value)
})
